import { render } from "./AddService.vue?vue&type=template&id=b06aa8f0"
import script from "./AddService.vue?vue&type=script&lang=js"
export * from "./AddService.vue?vue&type=script&lang=js"

import "./AddService.vue?vue&type=style&index=0&id=b06aa8f0&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__